import * as React from "react";

interface ClipboardListIconProps {
    className?: string;
    onClick?: () => void;
}

export class ClipboardListIcon extends React.Component<ClipboardListIconProps> {
    render() {
        return (
            <svg className={this.props.className} onClick={this.props.onClick} width="32" height="33" viewBox="0 0 32 33" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g id="clipboard-list" clipPath="url(#clip0_202_6394)">
                    <path id="Vector" d="M25 4.5H20C20 2.29375 18.2063 0.5 16 0.5C13.7937 0.5 12 2.29375 12 4.5H7C5.34375 4.5 4 5.84375 4 7.5V29.5C4 31.1562 5.34375 32.5 7 32.5H25C26.6562 32.5 28 31.1562 28 29.5V7.5C28 5.84375 26.6562 4.5 25 4.5ZM10 27C9.16875 27 8.5 26.3312 8.5 25.5C8.5 24.6688 9.16875 24 10 24C10.8313 24 11.5 24.6688 11.5 25.5C11.5 26.3312 10.8313 27 10 27ZM10 21C9.16875 21 8.5 20.3312 8.5 19.5C8.5 18.6688 9.16875 18 10 18C10.8313 18 11.5 18.6688 11.5 19.5C11.5 20.3312 10.8313 21 10 21ZM10 15C9.16875 15 8.5 14.3313 8.5 13.5C8.5 12.6687 9.16875 12 10 12C10.8313 12 11.5 12.6687 11.5 13.5C11.5 14.3313 10.8313 15 10 15ZM16 3C16.8313 3 17.5 3.66875 17.5 4.5C17.5 5.33125 16.8313 6 16 6C15.1687 6 14.5 5.33125 14.5 4.5C14.5 3.66875 15.1687 3 16 3ZM24 26C24 26.275 23.775 26.5 23.5 26.5H14.5C14.225 26.5 14 26.275 14 26V25C14 24.725 14.225 24.5 14.5 24.5H23.5C23.775 24.5 24 24.725 24 25V26ZM24 20C24 20.275 23.775 20.5 23.5 20.5H14.5C14.225 20.5 14 20.275 14 20V19C14 18.725 14.225 18.5 14.5 18.5H23.5C23.775 18.5 24 18.725 24 19V20ZM24 14C24 14.275 23.775 14.5 23.5 14.5H14.5C14.225 14.5 14 14.275 14 14V13C14 12.725 14.225 12.5 14.5 12.5H23.5C23.775 12.5 24 12.725 24 13V14Z" fill="#973794" />
                </g>
                <defs>
                    <clipPath id="clip0_202_6394">
                        <rect width="32" height="32" fill="white" transform="translate(0 0.5)" />
                    </clipPath>
                </defs>
            </svg>
        );
    }
}

